import { render, staticRenderFns } from "./ElectromagneticChargingViz.vue?vue&type=template&id=2a3aeb34&scoped=true"
import script from "./ElectromagneticChargingViz.vue?vue&type=script&lang=js"
export * from "./ElectromagneticChargingViz.vue?vue&type=script&lang=js"
import style0 from "./ElectromagneticChargingViz.vue?vue&type=style&index=0&id=2a3aeb34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3aeb34",
  null
  
)

export default component.exports